export default "__VITE_ASSET__DdxE9T5A__ 584w";